/**
 * guideNavigationResolver
 *
 * guide mode에서 인증 완료 후 어느 경로로 이동할지 결정하는 순수 함수.
 *
 * "왜 별도 파일인가": 조건 분기가 3단계(consent → training → list)로 명확하고
 * 훅 상태나 React 생명주기와 무관하므로 순수 함수로 추출해 테스트를 용이하게 한다.
 */

import { appendConsentEntryMode } from '@/pages/complete/shared/consentCompletionFlow';

interface GuideNavigationParams {
  token: string;
  mode?: string;
  project_id?: string;
  consent_status?: string;
  training_status?: string;
  training_performer?: string;
  entry?: string;
}

/**
 * Step2 응답 기반으로 이동할 경로를 결정한다.
 *
 * guide mode + project_id가 있을 때:
 *   1. consent 미완료 → /consent
 *   2. consent 완료 + training 미완료 + CRC_ONLY 아님 → /training
 *   3. 나머지 → /list
 * 그 외: /list
 */
export function resolveGuideTargetPath({
  token,
  mode,
  project_id,
  consent_status,
  training_status,
  training_performer,
  entry,
}: GuideNavigationParams): string {
  if (mode !== 'guide' || !project_id) {
    return `/s/${token}/list`;
  }

  const consentDone = consent_status === 'COMPLETED';
  const trainingDone = training_status === 'COMPLETED';
  const isCrcOnly = training_performer === 'CRC_ONLY';

  if (!consentDone) {
    return `/s/${token}/consent?${appendConsentEntryMode(project_id, entry === 'notice' ? 'notice' : 'direct')}`;
  }
  if (!trainingDone && !isCrcOnly) {
    return `/s/${token}/training?projectId=${project_id}`;
  }
  return `/s/${token}/list`;
}

export function shouldReplaceGuideEntryHistory(targetPath: string): boolean {
  return targetPath.includes('/consent?') || targetPath.includes('/training?');
}
